import { useState } from 'react';
import Button from '../../components/Button/Button';
import Loader from '../../components/Loader/Loader';
import { useSurveySessionRecording } from '../../hooks/useSurveySessions';
import styles from './VoiceSurveys.module.scss';

const NOT_FOUND = 404;

const errorMessage = (error) =>
  error.response?.status === NOT_FOUND ? 'No recording for this call.' : "Couldn't load the recording.";

// The recording is fetched only when the admin presses play. Render it with
// key={session.id} so switching calls resets the player.
export const VoiceSurveyRecording = ({ session }) => {
  const [enabled, setEnabled] = useState(false);
  const [refreshed, setRefreshed] = useState(false);
  const { recording, error, loading, refresh } = useSurveySessionRecording(session.id, { enabled });

  if (!session.has_recording_ids) {
    return <p className={styles.empty}>No recording for this call.</p>;
  }

  if (!enabled) {
    return <Button.BLACK_OUTLINED onClick={() => setEnabled(true)}>Play recording</Button.BLACK_OUTLINED>;
  }

  // The presigned URL lasts 15 minutes; if playback fails, fetch a fresh one once.
  const handleAudioError = () => {
    if (!refreshed) {
      setRefreshed(true);
      refresh();
    }
  };

  return (
    <Loader isLoading={loading}>
      {error && <p className={styles.empty}>{errorMessage(error)}</p>}
      {recording && (
        <audio className={styles.recording} controls autoPlay src={recording.url} onError={handleAudioError} />
      )}
    </Loader>
  );
};
